export default {
  // undefined in test suites (.env not read)
  backUrl: process.env.VUE_APP_BACK_URL,
  toAbsolute(url) {
    return this.backUrl + url;
  },

  login: "/api/login",
  oauth: "/oauth/authenticate/google",
  oauthSpreadsheets: "/sso/authenticate/google",
  users: "/api/users/",
  brands: "/api/brands/",
  shareUrl: "/api/disneyland/shareUrl",
  updateMessages: "/api/disneyland/updateMessages",
  getCreativeSetsMessages: "/api/disneyland/getCreativeSetsMessages",
  getCreativeSetsData: "/api/disneyland/getCreativeSetsData",
  downloadCsv: "/api/disneyland/downloadCsv",
  checkSpreadsheetUrl: "/api/disneyland/checkSpreadsheetUrl",
  getStrategiesSheet: "/api/disneyland/decision-tree/getSheet",

  saveInitDataToDb: "/api/disneyland/saveInitDataToDb",
  getMarkets: "/api/disneyland/getMarkets",
  getCreativeSetAssets: "/api/disneyland/getCreativeSetAssets",
  getMessagesByMarket: "/api/disneyland/getMessagesByMarket",
  getVariantsByBundleMarketAndSize: "/api/disneyland/getVariantsByBundleMarketAndSize",
  updateCampaignDataPrevLinks: "/api/disneyland/updateCampaignDataPrevLinks",

  medias: "/api/medias/",
  email: "/api/email/",
  update: "/api/users/updateSpreadsheet",
  readToken: "/external/readToken",
  getExternalSheets: "/external/getSheets",
  creativeSetIndexExternal: "/external/creativeSetIndex",
  adblock: "/ad/ads.js",

  currentUser() {
    return this.users + "currentUser";
  },
  updateAuthUsers() {
    return this.users + "updateAuthUsers";
  },
  oAuthAccessToken() {
    return this.users + "oAuthAccessToken";
  },
  brand(brandId) {
    return this.brands + brandId;
  },
  creativeSets(brandId) {
    return this.brand(brandId) + "/creative-sets/";
  },
  creativeSet(brandId, creativeSetId) {
    return this.creativeSets(brandId) + creativeSetId;
  },
  syncKits(brandId) {
    return this.brand(brandId) + "/kitsDLP/";
  },
  backupFolder(spreadsheetId) {
    return `/generated-kits/${spreadsheetId}/`;
  },
  backupZip(spreadsheetId) {
    return this.backupFolder(spreadsheetId) + "DLP.zip";
  },
  backupImage(spreadsheetId) {
    return this.backupFolder(spreadsheetId) + "300x250.jpg";
  },
  media(mediaId) {
    return this.medias + mediaId;
  },
  showMedia(mediaId) {
    return this.medias + mediaId + "/showMedia";
  },
  originalMedia(mediaId) {
    return this.medias + mediaId + "/original";
  },
  mediaUpload() {
    return this.medias + "upload";
  },
  mediaUploadDrive() {
    return this.medias + "uploadDrive";
  },
  mediaDownloadDrive(id) {
    return this.medias + "downloadDrive/" + id;
  },
  withParams(route, params) {
    route += "?";
    for (const key in params) {
      route += key + "=" + params[key] + "&";
    }
    return route;
  },
};
